import React, { Component, Fragment } from "react";
import "./header.css";
import logo from "../../style/images/logo.png";
import logo2 from "../../style/images/logo2.png";
import { Login } from "../accounts/login/login";
import { Register } from "../accounts/register/register";
import { Menu, Dropdown, Card } from "antd";
//imports for dropdown images
import testimage from "../../style/images/home/profile dropdown/test image.png";
import goldTrophy from "../../style/images/home/profile dropdown/gold cup.png";
import silverTrophy from "../../style/images/home/profile dropdown/silver cup.png";
import bronzeTrophy from "../../style/images/home/profile dropdown/bronze cup.png";

export default class Header extends Component {
  constructor() {
    super();
    this.disableLogin = this.disableLogin.bind(this);
    this.disableRegister = this.disableRegister.bind(this);
    this.gotoLoginPage = this.gotoLoginPage.bind(this);
    this.gotoSignupPage = this.gotoSignupPage.bind(this);
  } 
  handleMenuClick = e => { 
    if(e.key=='0')
    this.props.history.push('./editprofile')
    console.log('click', e);
  }
  DropDownProfile = (
    <Menu  onClick={this.handleMenuClick}>
      <Menu.Item key="0">
        <div className="row">
          <div className="col-md-6">
            <img src={testimage} />
          </div>
          <div className="col-md-6 playerName">
            <p><b >Player<br/> Name</b></p>
          </div>
        </div>
      </Menu.Item>

      <Menu.Item key="1">
        <div className="row">
          <div className="col-xs-5">
            <p className="dropdownP"><b>7</b></p>
          </div>
          <div className="col-xs-7">
            <p className="dropdownT">
              TOURNAMENTS
              <br /> WON
            </p>
          </div>
        </div>
      </Menu.Item>

      <Menu.Item key="3">
        <div className="row">
          <div className="col-xs-5">
            <p  className="dropdownP"><b>125</b></p>
          </div>
          <div className="col-xs-7">
            <p className="dropdownT">GAMES WON</p>
          </div>
        </div>
      </Menu.Item>
      <Menu.Item key="4">
        <div className="row">
          <div className="col-xs-5">
            <p  className="dropdownP"><b>35</b></p>
          </div>
          <div className="col-xs-7">
            <p className="dropdownT">LEVEL</p>
          </div>
        </div>
      </Menu.Item>
      <Menu.Item key="5" >
        <div className="row">
          <div className="col-xs-12">
            <p style ={{textAlign:'right'}} className="dropdownT" >TROPHY COUNT</p>
          </div>
        </div>
      </Menu.Item>
      <Menu.Item key="6" className="trophies">
        <div className="row " style={{marginRight:'0'}}>
          <div className="col-xs-4">
            <img src={goldTrophy} />
            <p style={{ paddingLeft: "60%", color: "gold" }}>2</p>
          </div>
          <div className="col-xs-4">
            <img src={silverTrophy} />
            <p style={{ paddingLeft: "60%", color: "silver" }}>2</p>
          </div>
          <div className="col-xs-4">
            <img src={bronzeTrophy} />
            <p style={{ paddingLeft: "60%", color: "darkgoldenrod" }}>2</p>
          </div>
        </div>
      </Menu.Item>
    </Menu>
  );
  state = {
    enablelogin: false,
    enableRegister: false
  };
  login() {
    console.log("Going to open login model " + this.state.enablelogin);
    this.setState({
      enablelogin: true
    });
  }
  disableLogin() {
    this.setState({
      enablelogin: false
    });
    console.log("Going to close login model " + this.state.enablelogin);
  }
  Register() {
    console.log("Going to open login model " + this.state.enablelogin);
    this.setState({
      enableRegister: true
    });
  }
  disableRegister() {
    this.setState({
      enableRegister: false
    });
    console.log("Going to close login model " + this.state.enablelogin);
  }
  gotoLoginPage() {
    this.setState({
      enableRegister: false,
      enablelogin: true
    });
  }
  gotoSignupPage() {
    this.setState({
      enableRegister: true,
      enablelogin: false
    });
  }
  render() {
    return (
      <Fragment>
        <nav className="navbar navbar-inverse">
          <div className="container-fluid">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                data-toggle="collapse"
                data-target="#myNavbar"
              >
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <a className="navbar-brand" href="/">
                <span className="span">
                  <img src={logo} className="logo" />
                  <img src={logo2} />
                </span>
              </a>
            </div>
            <div
              className="collapse navbar-collapse navbar-right"
              id="myNavbar"
            >
              <ul className="nav navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href="./singletournament">
                    <i className="fas fa-trophy" />
                    TOURNAMENTS <span className="sr-only">(current)</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#">
                    <i className="fas fa-gamepad" />
                    PRACTICE
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#">
                    <i className="fas fa-play" />
                    WATCH TO WIN
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#">
                    <i className="fas fa-question" />
                    HELP
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" onClick={() => this.Register()}>
                    SIGN UP
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link last" onClick={() => this.login()}>
                    LOG IN{" "}
                  </a>
                </li>
                <li className="nav-item">
                  <Dropdown overlay={this.DropDownProfile} trigger={["click"]} placement="topRight">
                    <a className="ant-dropdown-link" href="#">
                      <span className="login">
                        <i className="fas fa-user" />
                      </span>
                    </a>
                  </Dropdown>

                  {/* <a data-toggle="dropdown">
                    <span className="login">
                      <i className="fas fa-user" />
                    </span>
                  </a>

                  <div className="dropdown-menu">
                    <div className="row">
                      <div className="col-xs-2" />
                      <div className="col-xs-8">{this.DropDownProfile}</div>
                    </div>
                  </div> */}
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {this.state.enablelogin ? (
          <Login
            disableLogin={this.disableLogin}
            gotoSignupPage={this.gotoSignupPage}
            {...this.props}
          />
        ) : null}

        {this.state.enableRegister ? (
          <Register
            disableRegister={this.disableRegister}
            gotoLoginPage={this.gotoLoginPage}
            {...this.props}
          />
        ) : null}
      </Fragment>
    );
  }
}
